<template>
  <div class="kl-brochure">
    <div class="kl-brochure__grid">
      <article class="kl-brochure__card">
        <div class="kl-brochure__top">
          <span class="kl-brochure__badge">PDF</span>
          <h3 class="kl-brochure__title">
            {{ $t("home.homeView.klInnovationTitle") }}
          </h3>
        </div>
        <p class="kl-brochure__desc">
          {{ $t("home.homeView.klInnovationDescription") }}
        </p>
        <b-button
          variant="none"
          class="kl-brochure__btn"
          @click="openKLInnovation()"
        >
          <span>{{ $t("home.homeView.download") }}</span>
        </b-button>
      </article>

      <article class="kl-brochure__card">
        <div class="kl-brochure__top">
          <span class="kl-brochure__badge">PDF</span>
          <h3 class="kl-brochure__title">
            {{ $t("home.homeView.klAssessmentTitle") }}
          </h3>
        </div>
        <p class="kl-brochure__desc">
          {{ $t("home.homeView.klAssessmentDescription") }}
        </p>
        <b-button
          variant="none"
          class="kl-brochure__btn"
          @click="openKLAssesment()"
        >
          <span>{{ $t("home.homeView.download") }}</span>
        </b-button>
      </article>
    </div>
  </div>
</template>

<script>
import { brochureUrl } from "@/utils/globals";

export default {
  name: "Brochure",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    openKLAssesment() {
      const language = this.$i18n.locale || "es";
      const url = brochureUrl(language == "en" ? "FOLLETO_KLASSESMENT_INGLES.pdf" : "FOLLETO_KLASSESMENT_ESPAÑOL.pdf");
      window.open(url, "_blank");
    },
    openKLInnovation() {
      const language = this.$i18n.locale || "es";
      const url = brochureUrl(language == "en" ? "FOLLETO_KLINNOVATION_INGLES.pdf" : "FOLLETO_KLINNOVATION_ESPAÑOL.pdf");
      window.open(url, "_blank");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
/* ============================================================
   KeyLearning · Brochure (folletos de producto)
   ============================================================ */
.kl-brochure {
  /* Migrado al sistema global de tokens (utils/styles_kl.css). */
  --kl-blue: var(--kl-color-primary);
  --kl-blue-dark: var(--kl-color-primary-deep);
  --kl-teal: var(--kl-color-secondary);
  --kl-ink: var(--kl-text-heading);
  --kl-text: var(--kl-text-body);
  --kl-card: var(--kl-surface);
  --kl-border: var(--kl-border-soft);

  max-width: 1180px;
  margin: 0 auto;
  padding: 0 var(--kl-space-6) 40px;
}
.kl-brochure__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 36px;
}

/* Tarjeta */
.kl-brochure__card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--kl-card);
  border: 1px solid var(--kl-border);
  border-radius: 22px;
  padding: 40px 38px 34px;
  box-shadow: var(--kl-shadow-lg);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  overflow: hidden;
}
.kl-brochure__card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
}
.kl-brochure__card:hover {
  transform: translateY(-8px);
  box-shadow: var(--kl-shadow-lg-hover);
}

.kl-brochure__top {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}
.kl-brochure__badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
  color: #ffffff;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-small);
  letter-spacing: 0.5px;
  box-shadow: 0 8px 18px rgba(0, 110, 200, 0.28);
}
.kl-brochure__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-md);
  line-height: var(--kl-lh-tight);
  margin: 0;
  background: linear-gradient(
    135deg,
    var(--kl-blue-dark) 0%,
    var(--kl-teal) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.01em;
}
.kl-brochure__desc {
  flex: 1;
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-relaxed);
  color: var(--kl-text);
  margin: 0 0 28px;
  text-align: justify;
}

/* Botón */
.kl-brochure__btn {
  align-self: center;
  display: inline-flex;
  align-items: center;
  padding: 0 20px 0 20px;
  height: 54px;
  border: none;
  border-radius: var(--kl-radius-pill);
  background: linear-gradient(135deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
  color: #ffffff;
  font-weight: var(--kl-fw-semibold);
  font-size: var(--kl-fs-caption);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  box-shadow: 0 10px 24px rgba(0, 110, 200, 0.28);
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
}
.kl-brochure__btn:hover {
  color: #ffffff;
  transform: translateY(-2px);
  filter: brightness(1.05);
  box-shadow: 0 14px 30px rgba(0, 110, 200, 0.35);
}
.kl-brochure__btn img {
  width: 38px;
  height: 38px;
  padding: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}

@media (max-width: 900px) {
  .kl-brochure__grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .kl-brochure {
    padding: 0 22px 32px;
  }
}
</style>
